// Kiid Accordion: opens one answer at a time. One click handler serves every Kiid Accordion section on the page.
(function () {
  if (window.__kiidAccordionReady) return;
  window.__kiidAccordionReady = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.kacc__btn');
    if (!button) return;

    var inner = button.closest('.kacc__inner');
    var body = button.nextElementSibling;
    var wasOpen = body.classList.contains('is-open');

    inner.querySelectorAll('.kacc__body').forEach(function (item) {
      item.classList.remove('is-open');
    });
    inner.querySelectorAll('.kacc__btn').forEach(function (item) {
      item.setAttribute('aria-expanded', 'false');
    });

    if (!wasOpen) {
      body.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }
  });
})();
